const press = [
  {
    "title": "Little Black Book",
    "headline": "antoni Captures the Iconic Design of Mercedes Benz AG",
    "url": "https://www.lbbonline.com/news/antoni-captures-the-iconic-design-of-mercedes-benz-ag"
  },
  {
    "title": "Horizont",
    "headline": "Hyundai Ioniq x Horizont",
    "url": "https://www.horizont.net/agenturen/nachrichten/-ioniq-mit-diesem-futuristischen-manifest-inszeniert-jung-von-matt-die-elektromarke-von-hyundai-187265"
  },
  {
    "title": "W&V",
    "headline": "Hyundai Ioniq x WuV",
    "url": "https://www.wuv.de/agenturen/hyundai_und_jung_von_matt_bereiten_ioniq_mega_aufritt"
  },
  {
    "title": "Shoot",
    "headline": "AKKURAT Studios signs Amber Grace Johnson",
    "url": "https://www.shootonline.com/newsbriefs/akkurat-Studios-Signs-Director-Amber-Grace-Johnson-Representation-Germany"
  },
  {
    "title": "Highsnobiety",
    "headline": "GmbH x Guest on Earth",
    "url": "https://www.highsnobiety.com/p/gmbh-not-in-paris/"
  },
  {
    "title": "shots",
    "headline": "Sekou Andrews and The String Theory – Love Says",
    "url": "https://shots.net/news/view/love-says-many-things-but-will-we-listen"
  }
];

export default press;
